import { useRedux } from '../index';
import { commentAdminDelete, commentAdminUpdate, commentAdminViewAll, commentAdminViewDetails, commentUserGet, commentUserSend } from '../../redux/cms/comment/actions';
import { CommentFilter, CommentNew } from '../../types/cms/comment';

export default function useComment() {
    const { dispatch, appSelector } = useRedux();
    const { apiSuccess, adminAllComments, adminCommentDetails, sendSuccess, userViewComments, deleteSuccess, updateSuccess, loading, error } = appSelector((state) => ({
        apiSuccess: state.Comment.apiSuccess,
        adminAllComments: state.Comment.adminAllComments,
        adminCommentDetails: state.Comment.adminCommentDetails,
        userViewComments: state.Comment.userViewComments,
        sendSuccess: state.Comment.sendSuccess,
        deleteSuccess: state.Comment.deleteSuccess,
        updateSuccess: state.Comment.updateSuccess,
        loading: state.Comment.loading,
        error: state.Comment.error,
    }));

    const adminDeleteComment = (domain: string, commentId: string) => {
        dispatch(commentAdminDelete(domain, commentId));
    };

    const userLoadComments = (domain: string, domainId: string) => {
        dispatch(commentUserGet(domain, domainId));
    };

    const userSendComment = (data: CommentNew) => {
        dispatch(commentUserSend(data));
    };

    const adminLoadAllComments = (props: CommentFilter) => {
        dispatch(commentAdminViewAll(props));
    };

    const adminLoadCommentDetails = (id: string, domain: string) => {
        dispatch(commentAdminViewDetails(id, domain));
    };

    const adminUpdateComment = (commentData: CommentNew) => {
        dispatch(commentAdminUpdate(commentData));
    };

    return {
        loading,
        error,
        apiSuccess,
        sendSuccess,
        deleteSuccess,
        adminDeleteComment,
        adminUpdateComment,
        adminAllComments,
        adminLoadAllComments,
        adminLoadCommentDetails,
        userViewComments,
        adminCommentDetails,
        userLoadComments,
        userSendComment,
        updateSuccess,
    };
}
